import { FormGroup } from "@angular/forms";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";
import { NexsysIntegrationConfig } from "./product.model";

export const disabledIntegration = (formGroup: FormGroup) => {
	formGroup.get('nexsys.enabled')?.setValue(false);
	formGroup.get('valutrust.enabled')?.setValue(false);
	formGroup.get('xpanse.enabled')?.setValue(false);
	formGroup.get('fnc.enabled')?.setValue(false);
	formGroup.get('integration.enabled')?.setValue(false);
}

export const NEXSYS_FORM_CONFIG = {
	nexsys:{
		enabled: {
			path: 'nexsys.enabled',
			DataType: 'Boolean',
			DisplayText: `Nexsys`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					disabledIntegration(formGroup);
					formGroup.get('nexsys')?.setValue(new NexsysIntegrationConfig());
					formGroup.get('nexsys.enabled')?.setValue($event.checked);
					formGroup.get('nexsys').updateValueAndValidity();
				},
			},
		},
		isDefaultProduct: {
			path: 'nexsys.isDefaultProduct',
			DataType: 'Boolean',
			DisplayText: `Default Product Configuration`,
			Name: 'isDefaultProduct',
			customClass: 'product-form-switch ms-5',
			required:false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('nexsys.productId')?.setValue(null);
					formGroup.get('nexsys.productName')?.setValue(null);

					if ($event.checked) {
						formGroup.get('isOrganizationLevel')?.setValue(false);
						formGroup.get('nexsys.productId')?.setValue('unknown');
						formGroup.get('nexsys.productName')?.setValue(null);
					}

					formGroup.get('nexsys').updateValueAndValidity();
				},
			},
		},
		productId: {
			DataType: 'Selector',
			path: 'nexsys.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			defaultValue: 'unknown',
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: ValidationContext) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('isDefaultProduct') === false ) && jsonModelService.FindValue('enabled');
			},
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[ indexOption ];
						formGroup.get('integration.productName')?.setValue(option?.label);
					} else {
						formGroup.get('integration.productId')?.setValue(null);
						formGroup.get('integration.productName')?.setValue(null);
					}
				},
			},
		},
		productName: {
			DataType: 'String',
			path: 'nexsys.productId',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			required: false,
			hidden: true,
		},
		isFhaProduct: {
			path: 'nexsys.isFhaProduct',
			DataType: 'Boolean',
			DisplayText: `Is a FHA Product`,
			Name: 'isFhaProduct',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				if (optionSelected) {
					control?.setValue(false, { onlySelf: true, emitEvent: false })
				}
				return (optionSelected === false) || false;

			}
		},
		isOrderIncomeStatement: {
			path: 'nexsys.isOrderIncomeStatement',
			DataType: 'Boolean',
			DisplayText: `Is Order Income Statement`,
			Name: 'isOrderIncomeStatement',
			customClass: 'product-form-switch',
			required: false,
			hidden: true,
			defaultValue: false,
		},
		isOrderRentSchedule: {
			path: 'nexsys.isOrderRentSchedule',
			DataType: 'Boolean',
			DisplayText: `Is Order Rent Schedule`,
			Name: 'isOrderRentSchedule',
			customClass: 'product-form-switch',
			required: false,
			hidden: true,
			defaultValue: false
		},
		defaultFhaNumber: {
			path: 'nexsys.defaultFhaNumber',
			DataType: 'String',
			DisplayText: `Default FHA Number`,
			Name: 'defaultFhaNumber',
			customClass: '',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isFhaProduct');
				return optionSelected || false;

			}
		},
		orderAttribute: {
			DataType: 'Selector',
			path: 'nexsys.orderAttribute',
			UIControl: 'MultiSelect',
			DisplayText: 'Include order attribute',
			label: 'Include order attribute',
			Name: 'orderAttribute',
			options: [],
			required: false,
			customClass: 'order-attribute-multiselect',
			UIOptions: {
				isArray: true,
				ShowClearButton: true,
				showLabel: true,
			},
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				const optionEnabled = jsonModelService.FindValue('enabled');
				return (optionSelected === false) && optionEnabled || false;

			}
		}
	}

}
